import { SortType, TableSortConfiguration } from '@platform-workspace/design-system';

import { BaseList, SortTypeDto } from '../interfaces';

export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_PAGE_NUMBER = 0;

export const DEFAULT_BASE_LIST_STATE: BaseList<any> = {
  page: {
    totalElements: 0,
    totalPages: 0,
    number: DEFAULT_PAGE_NUMBER,
    size: DEFAULT_PAGE_SIZE,
  },
  content: [],
};

export const DEFAULT_BASE_SORT_CONFIGURATION_STATE: TableSortConfiguration = {
  sortType: null,
  selectedColumn: null,
};

export const SORT_TYPE_MAP: Record<SortType, SortTypeDto> = {
  [SortType.Asc]: 'asc',
  [SortType.Desc]: 'desc',
};
